"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Heading = _interopRequireDefault(require("../Heading"));

var H1 = (0, _styledComponents.default)(_Heading.default).withConfig({
  displayName: "H1",
  componentId: "tkst7d-0"
})([""]);
H1.propTypes = _Heading.default.propTypes;
H1.defaultProps = Object.assign({}, _Heading.default.defaultProps, {
  tagName: 'h1'
});
H1.displayName = 'H1';
var _default = H1;
exports.default = _default;
module.exports = exports.default;